export const INITIAL = 0;
export const INITIAL_ULID = '';
export const ALL = 0;

export const FILTER_PREFIX_NAME_CHAPTER = '【章】';
export const FILTER_PREFIX_VALUE_CHAPTER = 'CHAPTER';
export const FILTER_PREFIX_NAME_PRACTICE = '【課題】';
export const FILTER_PREFIX_VALUE_PRACTICE = 'PRACTICE';
